import { inject, Injectable } from '@angular/core';
import { CommonHttpService } from '../../common-http.service';
import { IFeaturedAuctions } from '../../../models/IFeaturedAuctions';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FeaturedAuctionsService {

  private httpService = inject(CommonHttpService)

  constructor() { }

  public getFeaturedAuctions(): Observable<IFeaturedAuctions[]> {

    const url = `${environment.apiUrl}/v3/bidder-community/featured-auctions`;

    return this.httpService.get<IFeaturedAuctions[]>(url).pipe(
      catchError((error: HttpErrorResponse) => {
        const errorMsg = typeof error.error === 'string' ? error.error : 'Unknown Error';
        return throwError(() => new Error(errorMsg));
      })
    );

  }


}
